import { Dispatch, SetStateAction } from 'react'

import { Link } from 'react-scroll'

import SellerTransferList from 'components/GoalWizard/SellerTransferList'
import { IUserWorking } from 'store/modules/goal/types'
import { ICurrentGoalProps } from '../..'
import { distributeUserWeights } from 'utils/distributeUserWeights'

import {
  CreateIcon,
  EditButton,
  NextStepButton
} from 'views/Goals/components/AddGoal/style'
import { Content } from '../../styles'
import { Container } from './styles'

interface SelectUsersSectionProps {
  goal: ICurrentGoalProps
  usersWorking: IUserWorking[]
  users: IUserWorking[]
  usersAccWeight: number
  handleSubmitSectionsPicker: () => void
  handleEditSectionsPicker: () => void
  setUsers: Dispatch<SetStateAction<IUserWorking[]>>
  setUsersWorking: Dispatch<SetStateAction<IUserWorking[]>>
}

export const SelectUsersSection = ({
  goal,
  users,
  usersWorking,
  usersAccWeight,
  handleSubmitSectionsPicker,
  handleEditSectionsPicker,
  setUsers,
  setUsersWorking
}: SelectUsersSectionProps) => {
  const distributeWeights = (usersToDistribute: IUserWorking[]) => distributeUserWeights(usersToDistribute, goal?.distribute)

  // USERS WORKING
  const handleAddSellerToGoal = (user: IUserWorking) => {
    setUsers(state => state.filter(u => u.userId?._id !== user.userId?._id))

    const updatedUsersWorking = [
      ...usersWorking,
      { ...user, dsr: true, active: true }
    ]
    const distributedUsersWeight = distributeWeights(updatedUsersWorking)
    setUsersWorking(distributedUsersWeight)
  }

  const handleRemoveSellerFromGoal = (user: IUserWorking) => {
    setUsers(state => [
      ...state,
      { ...user, weightLocked: false, active: false }
    ])

    const usersWorkingWithoutCurrentUser = [...usersWorking].filter(
      u => u.userId?._id !== user.userId?._id
    )
    const distributedUsersWeight = distributeWeights(usersWorkingWithoutCurrentUser)
    setUsersWorking(distributedUsersWeight)
  }

  const handleUpdateUserDSR = (user: IUserWorking, dsr: boolean) => {
    const updatedUsers = [...usersWorking].map(userW => {
      const isUserToBeUpdated = userW.userId?._id === user.userId?._id
      if (isUserToBeUpdated) {
        return {
          ...userW,
          dsr
        }
      }
      return userW
    })
    setUsersWorking(updatedUsers)
  }

  const handleUpdateUserWeight = (
    user: IUserWorking,
    type: string,
    weight: number
  ) => {
    const updatedUsers = [...usersWorking].map(userW => {
      const isUserToBeUpdated = userW.userId?._id === user.userId?._id
      // filtra pelo cara que foi alterado
      if (isUserToBeUpdated) {
        return {
          ...userW,
          goalWeight: +weight,
          weightLocked: type === 'fixed'
        }
      } // muda o peso dele e bloqueia ele para nao ser alterado novamente na redistribuição

      return userW
    })

    const distributedUsers = distributeWeights(updatedUsers)
    setUsersWorking(distributedUsers)
  }

  const handleUnlockWeightUsers = () => {
    setUsersWorking(state =>
      state.map(user => {
        user.weightLocked = false
        user.goalWeight = 1
        return user
      })
    )
  }

  const hasAccWeightError = usersAccWeight.toFixed(0) !== (usersWorking.length * 100).toFixed(0) && goal?.distribute
  const hasLockedWeights = usersWorking.some(user => user.weightLocked)

  const hasAtLeastOneUserWorking =
    Array.isArray(goal.usersWorking) &&
    usersWorking &&
    !(goal.usersWorking.length > 0) &&
    usersWorking.length > 0

  return (
    <Container>
      <Content isFilled={goal.usersWorking?.length > 0}>
        <h1>Selecione quem irá participar da meta</h1>
        <SellerTransferList
          data={goal}
          expectedWeight={usersWorking.length * 100}
          hasLockedWeights={hasLockedWeights}
          hasWeightError={Boolean(hasAccWeightError)}
          layout='individual'
          unlockTooltipId='locker-weight-tooltip'
          usersAccWeight={usersAccWeight}
          usersNotWorking={users}
          usersWorking={usersWorking}
          weightTooltipId='total-weight-tooltip'
          onAdd={handleAddSellerToGoal}
          onRemove={handleRemoveSellerFromGoal}
          onUnlockWeights={handleUnlockWeightUsers}
          onUpdateDsr={handleUpdateUserDSR}
          onUpdateWeight={handleUpdateUserWeight}
        />
      </Content>

      {hasAtLeastOneUserWorking ? (
        <Link to='monthGoals' offset={-170} smooth={true}>
          <NextStepButton
            onClick={handleSubmitSectionsPicker}
            disabled={usersWorking.length !== Number(usersAccWeight.toFixed(0)) / 100 && goal?.distribute}
            data-cy='pickSellersForGoalNextButton'
          >
            Avançar
          </NextStepButton>
        </Link>
      ) : (
        goal.usersWorking.length > 0 && (
          <EditButton onClick={handleEditSectionsPicker}>
            Alterar
            <CreateIcon />
          </EditButton>
        )
      )}
    </Container>
  )
}
